import { Box, Flex, Text, Radio, Button, VStack } from "@chakra-ui/react";

const ELEVATION_TYPES = [
  {
    id: "luxury",
    label: "Luxury",
    sub: "Premium design — high-end materials & finishes",
    icon: "🏰",
  },
  {
    id: "modern",
    label: "Modern",
    sub: "Contemporary design — balanced style & cost",
    icon: "🏡",
  },
  {
    id: "economy",
    label: "Economy",
    sub: "Simple & functional design — budget friendly finishes",
    icon: "🏠",
  },
];

// type -> budget bar segment mapping
const BUDGET_LEVELS = [
  { id: "economy", label: "Economy" },
  { id: "medium", label: "Medium" },
  { id: "luxury", label: "Luxury" },
];

const TYPE_TO_BUDGET = {
  economy: "economy",
  modern: "medium",
  luxury: "luxury",
};

export default function ElevationStepType({
  formData, setFormData, onNext, onBack, isLastStep, onSubmit,
}) {
  const elevationType = formData?.elevationType || "";
  const activeBudget = TYPE_TO_BUDGET[elevationType] || "";

  const handleSelect = (id) => {
    setFormData({ ...formData, elevationType: id });
  };

  const handleNext = () => {
    if (!elevationType) return;
    if (isLastStep) onSubmit(); else onNext();
  };

  return (
    <Box
      h="600px" w="100%" maxW="400px" mx="auto"
      display="flex" flexDirection="column" justifyContent="space-between"
      px={4} py={6}
    >
      <Box
        flex="1" minH="0" overflowY="auto" overflowX="hidden" pr={1}
        css={{ "&::-webkit-scrollbar": { width: "6px" }, "&::-webkit-scrollbar-thumb": { background: "#cbd5e0", borderRadius: "10px" } }}
      >
        <VStack spacing={3} align="stretch">
          <Box>
            <Text fontSize="17px" fontWeight="600" color="gray.800">Elevation Type</Text>
            <Text fontSize="12px" color="gray.500" mt={0.5}>
              Select the elevation type for your project
            </Text>
          </Box>

          {ELEVATION_TYPES.map((type) => {
            const isSelected = elevationType === type.id;
            return (
              <Box
                key={type.id}
                borderRadius="10px" overflow="hidden"
                border={isSelected ? "2px solid #319795" : "1px solid #E2E8F0"}
                cursor="pointer" transition="0.2s"
                _hover={{ borderColor: "cyan.400" }}
                onClick={() => handleSelect(type.id)}
              >
                <Flex align="center" px={3} py={3} bg={isSelected ? "cyan.50" : "white"}>
                  <Text fontSize="26px" mr={1} lineHeight="1">{type.icon}</Text>
                  <Radio
                    value={type.id} colorScheme="cyan"
                    isChecked={isSelected}
                    onChange={() => handleSelect(type.id)}
                  />
                  <Box ml={2}>
                    <Text fontSize="14px" fontWeight="600" color="gray.800">{type.label}</Text>
                    <Text fontSize="11px" color="gray.500">{type.sub}</Text>
                  </Box>
                </Flex>
              </Box>
            );
          })}

          {elevationType && (
            <Box mt={2} p={3} borderRadius="10px" bg="gray.50" border="1px solid" borderColor="gray.200">
              <Text fontSize="11px" color="gray.500" fontWeight="600" mb={2}>
                Estimated Budget Level
              </Text>
              <Flex gap="4px">
                {BUDGET_LEVELS.map((level) => {
                  const isActive = activeBudget === level.id;
                  return (
                    <Box key={level.id} flex="1">
                      <Box
                        h="8px" borderRadius="full"
                        bg={isActive ? "cyan.500" : "gray.200"}
                        transition="background 0.2s"
                      />
                      <Text
                        mt="4px" fontSize="10px" textAlign="center"
                        color={isActive ? "cyan.600" : "gray.400"}
                        fontWeight={isActive ? "700" : "400"}
                      >
                        {level.label}
                      </Text>
                    </Box>
                  );
                })}
              </Flex>
            </Box>
          )}
        </VStack>
      </Box>

      <Flex justify="space-between" gap={3} mt={4} flexShrink={0}>
        <Button onClick={onBack} variant="solid" bg="white" color="cyan.600"
          border="1px solid" borderColor="cyan.500" borderRadius="6px"
          minW="100px" h="40px" fontWeight="500" fontSize="14px" _hover={{ bg: "cyan.50" }}>
          ← Previous
        </Button>
        <Button onClick={handleNext} isDisabled={!elevationType} variant="solid"
          bg={elevationType ? "cyan.500" : "gray.300"} color="white"
          borderRadius="6px" minW="100px" h="40px" fontWeight="500" fontSize="14px" ml="auto"
          _hover={{ bg: elevationType ? "cyan.600" : "gray.300" }}
          _disabled={{ bg: "gray.300", color: "gray.500", cursor: "not-allowed" }}>
          {isLastStep ? "Submit" : "Next →"}
        </Button>
      </Flex>
    </Box>
  );
}